import { render, staticRenderFns } from "./RequestOverviewPage.vue?vue&type=template&id=13e7f52d"
import script from "./RequestOverviewPage.vue?vue&type=script&lang=js"
export * from "./RequestOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports